<mat-list [attr.aria-label]="'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.FUNCTIONS_DESCRIPTION' | translate">
  @for (form of forms().controls; track form; let i = $index) {
    <mat-list-item class="list-item">
      <div class="list-item-content">
        <div class="list-item-text">
          {{ form.controls.id.value }}
        </div>
        <button mat-icon-button (click)="toolFormDisplay.emit(form)" class="icon-button">
          <mat-icon class="icon">
            @if (form.enabled) {
              edit
            } @else {
              visibility
            }
          </mat-icon>
        </button>
        @if (form.enabled) {
          <button mat-icon-button class="icon-button" (click)="handleToolRemoved($event, $index)">
            <mat-icon class="icon">clear</mat-icon>
          </button>
        }
      </div>
    </mat-list-item>
  }
</mat-list>
<div class="tools">
  @if (showAddButton()) {
    <button mat-button (click)="handleToolAdd($event)">
      {{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.ADD_FUNCTION' | translate }}
    </button>
  }
</div>
